var path = '/pages/guestlists/views/rsvps-masterlist.tpl.html';
var html = "<div ng-if=\"vm.currentTab == 'rsvps'\">\n    <listview store=\"vm.store\" ng-if=\"vm.mode == 'listview'\"></listview>\n    <ng-include src=\"vm.editorTemplate\" ng-if=\"vm.mode == 'editor'\"></ng-include>\n</div>\n<div ng-if=\"vm.currentTab == 'changelog'\">\n    <al-entity-change-log entity=\"'rsvp'\"></al-entity-change-log>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/rsvps-masterlist.tpl.html
// module id = 2289
// module chunks = 1